import defaultSettings from '@/settings'

const { dashBoardManager } = defaultSettings

const state = {
    dashBoardManager,
    isShowModalPreview:false,
    isShowModalPreWarnRule:false,
    isShowModalSelectSetting:false,
    isShowModalLinkManager:false,
    modalData:{},
    // 当前编辑的看板名称
    dash_name:'',
    // 预警规则
    ruleSetting:{},
    // 计算变量列表
    warnVarNames:[],
    // 筛选配置信息
    selectSetting:{},
    // 链接信息管理
    linkInfo:[],
    // 看板名称
    dashHeader:undefined,
    loading:true,
    // 链接生成
    linkGenerate:{},

}
const mutations = {
  SET_ISSHOWMODALPREVIEW: (state, isShowModalPreview) => {
    state.isShowModalPreview=isShowModalPreview
  },
  SET_ISSHOWMODALPREWARNRULE: (state, isShowModalPreWarnRule) => {
    state.isShowModalPreWarnRule=isShowModalPreWarnRule
  },
  SET_MODALDATA: (state,modalData)=>{
    state.modalData = modalData
  },
  SET_DASHNAME:(state,dash_name)=>{
    state.dash_name=dash_name
  },
  SET_WARNRULESETTING:(state,ruleSetting)=>{
    state.ruleSetting=ruleSetting
  },
  SET_WARNVARNAMES:(state,warnVarNames)=>{
    state.warnVarNames=warnVarNames
  },
  SET_ISSHOWMODALSELECTSETTING: (state, isShowModalSelectSetting) => {
    state.isShowModalSelectSetting=isShowModalSelectSetting
  },
  SET_ISSHOWMODALLINKMANAGER:(state, isShowModalLinkManager) => {
    state.isShowModalLinkManager=isShowModalLinkManager
  },
  SET_SELECTSETTING:(state,selectSetting)=>{
    state.selectSetting=selectSetting
  },
  SET_LINKINFO:(state,linkInfo)=>{
    state.linkInfo=linkInfo
  },
  SET_DASHHEADER:(state,dashHeader)=>{
    state.dashHeader=dashHeader
  },
  SET_LOADING: (state, loading) => {
    state.loading=loading
  },
  SET_LINKGENERATE: (state, linkGenerate) => {
    state.linkGenerate=linkGenerate
  },
}
const actions = {
  //
  setIsShowModalPreview({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREVIEW', Info)
      resolve()
    })
  },
  setIsShowModalPreWarnRule({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALPREWARNRULE', Info)
      resolve()
    })
  },
  setIsShowModalSelectSetting({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALSELECTSETTING', Info)
      resolve()
    })
  },
  setModalData({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_MODALDATA', Info)
      resolve()
    })
  },
  setDashName({commit},dash_name){
    return new Promise((resolve,reject)=>{
      commit('SET_DASHNAME',dash_name)
      resolve()
    })
  },
  setWarnRuleSetting({commit},ruleSetting){
    return new Promise((resolve,reject)=>{
      commit('SET_WARNRULESETTING',ruleSetting)
      resolve()
    })
  },
  setSelectSetting({commit},selectSetting){
    return new Promise((resolve,reject)=>{
      commit('SET_SELECTSETTING',selectSetting)
      resolve()
    })
  },
  setWarnVarNames({commit},warnVarNames){
    return new Promise((resolve,reject)=>{
      commit('SET_WARNVARNAMES',warnVarNames)
      resolve()
    })
  },
  setLinkInfo({commit},linkInfo){
    return new Promise((resolve,reject)=>{
      commit('SET_LINKINFO',linkInfo)
      resolve()
    })
  },
  setIsShowModalLinkManager({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSHOWMODALLINKMANAGER', Info)
      resolve()
    })
  },
  setDashHeader({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_DASHHEADER', Info)
      resolve()
    })
  },
  setLoading({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', Info)
      resolve()
    })
  },
  setLinkGenerate({ commit }, Info) {
    return new Promise((resolve, reject) => {
      commit('SET_LINKGENERATE', Info)
      resolve()
    })
  }

  
}
const getters =  {
    // 获取所有看板名称
    dashNames (state) {
      const dashNames = []  
      for (let i in state.dashBoardManager){
          dashNames.push(i)
      }
      return dashNames
    },
    // 获取指定看板的所有box名称
    boxNames: (state) => (dashName) => {
        let boxs = []
        const dashBoard = state.dashBoardManager[dashName]
        if (dashBoard){
            boxs = dashBoard.boxs
        }else{
            // for debug
            console.log(`未查询到看板名${dashName}`)
        }
        return boxs
      },
    dash_name:(state)=>state.dash_name,
    isShowModalPreview: (state) => state.isShowModalPreview,
    isShowModalPreWarnRule: (state) => state.isShowModalPreWarnRule,
    isShowModalSelectSetting: (state) => state.isShowModalSelectSetting,
    isShowModalLinkManager: (state) => state.isShowModalLinkManager,
    ruleSetting: (state) => state.ruleSetting,
    selectSetting: (state) => state.selectSetting,
    linkInfo: (state) => state.linkInfo,
    dashHeader: (state) => state.dashHeader,
    warnVarNames: (state) => state.warnVarNames,
    modalData:(state) => state.modalData,
    loading:(state) => state.loading,
    linkGenerate:(state) => state.linkGenerate,
  }



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
